import * as React from 'react';
import { IImageProps, Image, Text } from '@lce/slice';
import { useSettings } from '@lce/api';
import { split as _split } from 'lodash';

export const SafeImage: React.FC<IImageProps> = ({ alt = '', src, ...props }) => {
  const fallbackUrl = _split(src, 'banner-assets');

  const [error, setError] = React.useState(false);
  //const { data: settings } = useSettings();

  return (
    <>
      {/* {settings?.CONFIG?.BANNERMATIC?.SHOW_FALLBACK_INDICATOR && error && <Text>Fallback Image</Text>} */}

      <Image
        {...props}
        alt={alt}
        src={src}
        onError={e => {
          (e.target as any).onerror = null;
          setError(true);
          (e.target as any).src = `/banner-assets${fallbackUrl[1]}`;
        }}
      />
    </>
  );
};
